import { TestTypeEnum } from '@doltech/utils/lib/constants';
import { isNil } from 'lodash';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { ReadingBottomNavigation } from '../components/BottomNavigation/ReadingBottomNavigation';
import { EditorDoingTest } from '../components/EditorDoingTest/EditorDoingTest';
import { TestContent } from '../components/TestContent';
import { TestProgress } from '../components/TestProgress';
import { DoTestHeaderDesktop } from '../mobile/DoTest/Reading/Header/DoTestHeaderDesktop';
import { useTestSubmissionStore } from '../model/test-submissions.hook';
import { ReadingGuidedTour } from './GuidedTour/ReadingGuidedTour';
import { ReadingTestLayout } from './ReadingTestLayout';
import { TestSubmission, TestSubmissionProps } from './TestSubmission';
import { LayoutPageHamburger } from '@doltech/ui/lib/layouts/pages/LayoutPageHamburger';

export interface ReadingTestSubmissionProps extends TestSubmissionProps {
  disableTestInfo?: boolean;
  disableSubmitAction?: boolean;
}

export const ReadingTestSubmission = observer((props: ReadingTestSubmissionProps) => {
  const { onSubmit, onSubmitWithEvents, disableTestInfo, disableSubmitAction, onQuit } = props;
  const testSubmissionStore = useTestSubmissionStore();
  const currentSection = testSubmissionStore.currentTestSection;

  if (isNil(currentSection) || testSubmissionStore.initialed === false) return null;

  const buildHeaderText = () => {
    return testSubmissionStore.testType === TestTypeEnum.FULL_TEST
      ? 'IELTS Online Test'
      : 'IELTS Reading Practice Test';
  };

  return (
    <TestSubmission
      onSubmit={onSubmit}
      onSubmitWithEvents={onSubmitWithEvents}
      disableSubmitAction={disableSubmitAction}
      enableEvent
    >
      <LayoutPageHamburger
        fullHeight
        header={
          <DoTestHeaderDesktop
            showQuitButton
            text={buildHeaderText()}
            onQuit={onQuit}
            testName={testSubmissionStore.name}
            skill={testSubmissionStore.skill}
            isReviewing={testSubmissionStore.isReviewing}
          />
        }
        footer={
          <ReadingBottomNavigation
            className="bottom-navigation"
            disableTestInfo={disableTestInfo}
            disableSubmitAction={disableSubmitAction}
            onSubmitWithEvents={onSubmitWithEvents}
          >
            <TestProgress />
          </ReadingBottomNavigation>
        }
      >
        <ReadingTestLayout expanded={testSubmissionStore.bottomNavigationExpanded}>
          <ContentWrapper className="content-wrapper">
            <EditorDoingTest
              key={currentSection?.id}
              initialValue={
                currentSection?.studentPassage
                  ? JSON.parse(currentSection?.studentPassage)
                  : currentSection?.getPassage()
              }
              selectionOnly
              withToolBar
              id="sidebar-left"
              onChange={(value) => {
                currentSection?.setStudentPassage(value);
              }}
            />

            <TestContent id="body-container" />
          </ContentWrapper>
        </ReadingTestLayout>
      </LayoutPageHamburger>
      <ReadingGuidedTour />
    </TestSubmission>
  );
});

const ContentWrapper = styled.div`
  > div > .content {
    height: 100%;
    padding: 16px 24px;
    overflow-y: auto;
    overflow-x: hidden;
  }
  #passage-container {
    padding: 0;
  }
  #sidebar-left {
    overflow-y: auto;
    overflow-x: hidden;
    padding: 0;
  }
`;
